import { DateInputFormik } from '@strata/react-date-time';
import { TextAreaFormik } from '@strata/react-inputs';
import { RadioButtonGroupFormik } from '@strata/react-radio-button-group';

export const GeneralCommunicationForm = () => (
    <>
        <RadioButtonGroupFormik
            name="communicationDirection"
            label="Communication Direction"
            required
            options={['Inbound', 'Outbound']}
        />
        <RadioButtonGroupFormik
            name="outreachOrganization"
            label="Organization"
            required
            options={['Health Plan', 'Pharmacy', 'Prescriber']}
        />
        <RadioButtonGroupFormik
            name="communicationType"
            label="Communication Type"
            required
            options={['Fax', 'Phone']}
        />
        <DateInputFormik id="priorAuthActivityDate" label="Date" required showTime />
        <TextAreaFormik id="note" label="Note" />
    </>
);
